import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import SystemSettingsActionButton from "../../../components/settings/SystemSettingsActionButton.js";
import sweetAlert, {
  sweetStatusAlert,
} from "../../../components/common/SweetAlert";
import { CityService } from "../../../service/settings/manage/city.service.js";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import Spinner from "react-bootstrap/Spinner";
import debounce from "lodash.debounce";
import "../../../components/admin/css/common.css";
import { ProvinceService } from "../../../service/settings/manage/province.service.js";
import SimpleReactValidator from "simple-react-validator";
import PageSpinner from "../../../components/common/spinner/PageSpinner";
import ContentWrapper from "../../../components/common/ContentWrapper";
import config from '../../../helper/config';
import {customerConstants} from "../../../helper/constants.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle
const customer = getCustomerFeatureFlag()
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent"
    }
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent"
    }
    break
  default:
    break
}

export default class ManageCity extends Component {
  constructor(props) {
    super(props);
    this.createValidationsInstance();
    this.state = {
      showModal: false,
      cityName: "",
      cityDescription: "",
      cities: [],
      provinces: [],
      province_id: "",
      isModified: false,
      modalType: false,
      currentPage: 0,
      totalCities: 10,
      search_term: "",
      limit: 10,
      offset: 0,
      isLoading: false,
      isTableDataLoading: true,
      editVisibility: true,
      addVisibility: true,
      deleteVisibility: false,
      isProvincesLoading: true,
    };
    this.debouncedHandleSearch = debounce(this.fetchCityData, 2000);
  }

  resetFormFields = () => {
    this.setState({
      cityName: "",
      cityDescription: "",
      province_id: "",
    });
  };

  componentDidMount() {
    // const staff_id = sessionStorage.getItem("staff_id");
    // this.getVisibilityCheck(staff_id);
    this.fetchCityData();
    this.fetchProvinceData();
  }

  //create validation object
  createValidationsInstance() {
    this.validator = new SimpleReactValidator();
  }

  //fetching city data with limit
  fetchCityData = () => {
    const { limit, offset, search_term } = this.state;
    CityService.getAllCitiesLimit(limit, offset, search_term)
      .then((response) => {
        if (response.success) {
          this.setState({
            cities: response.data.cities,
            totalCities: parseInt(response.data.count),
          });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching Cities. Please refresh the screen!",
            "error"
          );
        }
      })
      .catch((error) => {
        // Handle any error that occurred during the API call
        sweetStatusAlert(
          "Failed!",
          "Error fetching Cities. Please refresh the screen!",
          "error"
        );
      })
      .finally(() => {
        this.setState({ isTableDataLoading: false });
      });
  };

  //fetch province list
  fetchProvinceData = () => {
    ProvinceService.getAll().then((response) => {
      this.setState({ provinces: response.data, isProvincesLoading: true });
    });
  };

  //table pagination handle
  handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchCityData();
      }
    );
  };

  handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage
      },
      () => {
        this.fetchCityData();
      }
    );
  };

  //table rows handle
  handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
      {
        limit: newLimit,
        offset: newLimit * newPage, 
        isTableDataLoading: true,
        currentPage: newPage, 
      },
      () => {
        this.fetchCityData();
      }
    );
  };

  //handle properties and states
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(() => ({ [name]: value, isModified: true }));
  };

  //handle sweet alert for incomplete modifications
  handleSweetAlert = (modalType, modalVisibility) => {
    if (this.state.isModified) {
      sweetAlert().then((response) => {
        this.validator.hideMessages();
        this.validator.purgeFields();
        this.resetFormFields();
        this.modalType = false;
        this.setState(() => ({
          [modalVisibility]: response,
          isModified: false,
        }));
      });
    } else {
      this.validator.hideMessages();
      this.validator.purgeFields();
      this.resetFormFields();

      if (modalType) this.toggleAddCityModal();
      else this.toggleUpdateCityModal();
    }
  };

  //city modal state change
  toggleAddCityModal = (modalType) => {
    this.modalType = modalType;
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
    }));
  };

  //city updte modal state change
  toggleUpdateCityModal = (
    name,
    description,
    city_id,
    province_id,
    modalType
  ) => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
      cityName: name,
      cityDescription: description,
      city_id: city_id,
      province_id: province_id,
      modalType: modalType,
    }));
  };

  //handle the edit city
  handleEditSubmit = (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });
      const cityDetails = {
        name: this.state.cityName,
        description: this.state.cityDescription,
        province_id: this.state.province_id,
      };

      const cityId = this.state.city_id;

      CityService.update(cityDetails, cityId)
        .then((response) => {
          if (response.success) {
            this.setState({ showModal: false });
            // add logic to update the cities data in the component
            sweetStatusAlert("Success!", response.message, "success");
            this.setState({ isLoading: false });
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.fetchCityData();
          } else {
            this.setState({ isLoading: false });
            sweetStatusAlert("Failed!", response.message, "error");
          }
        })
        .catch((err) => {
          this.setState({ isLoading: false });
          sweetStatusAlert(
            "Failed!",
            "Unable to update the city information",
            "error"
          );
        });
    }
  };

  //handle the create city
  handleSubmit = (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });
      const { cityName, cityDescription, province_id } = this.state;
      const newcity = {
        name: cityName,
        description: cityDescription,
        province_id: province_id,
      };

      CityService.add(newcity)
        .then((response) => {
          if (response.success) {
            sweetStatusAlert("Success!", response.message, "success");
            this.setState({ isLoading: false });
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.fetchCityData();
            this.toggleAddCityModal(false);
          } else {
            this.setState({ isLoading: false });
            sweetStatusAlert("Failed!", response.message, "error");
          }
        })
        .catch((err) => {
          this.setState({ isLoading: false });
          sweetStatusAlert("Failed!", "Unable to create new city", "error");
        });
    }
  };

  //handle the search with pagination
  handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
      this.setState(
        {
          search_term,
          isTableDataLoading: true,
          offset: 0,
          currentPage: 0,
          searchError: false,
        },
        () => {
          this.debouncedHandleSearch();
        }
      );
    } else {
      this.setState({ search_term, searchError: true });
    }
  };

  render() {
    const {
      currentPage,
      limit,
      totalCities,
      isTableDataLoading,
      provinces,
      editVisibility,
      addVisibility,
      deleteVisibility,
      isLoading,
      province_id,
      cityName,
      cityDescription,
      isProvincesLoading,
    } = this.state;

    return (
      <>
            <ContentWrapper>
            <div className="row justify-content-between align-items-center py-5 mb-3">
                <div className="col-md-6 col-6"><h3 className='text-nowrap'>Manage City</h3></div>
                <div>
                  {addVisibility && (
                      <Button
                        className="insert-btn"
                        variant="primary"
                        onClick={() => this.toggleAddCityModal(true)}
                      >
                        Add City
                      </Button>
                    )}
                </div>
              </div>
              <div>
                <Form.Group
                  controlId="exampleForm.ControlInput1"
                  className="mb-2"
                >
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    onChange={this.handleSearch}
                    isInvalid={this.state.searchError}
                    // style={{ width: "18%" }}
                    className="col-md-3 col-12"
                  />
                  {this.state.searchError && (
                    <Form.Control.Feedback type="invalid">
                      Invalid input
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
                {isLoading && (
                  <PageSpinner id="show" text="Loading, Please wait!" />
                )}
                {isTableDataLoading && isProvincesLoading ? (
                  <div
                    className="loading-container"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "75vw",
                      height: "90vh"
                    }}
                  >
                    <Spinner animation="border" role="status">
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                  </div>
                ) : this.state.cities.length > 0 ? (
                  <div style={{ width: "100%", height: "90vh", overflow: "auto" }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell align="left" className="thead">
                            No
                          </TableCell>
                          <TableCell align="left" className="thead">
                            City Name
                          </TableCell>
                          <TableCell align="left" className="thead">
                            City Description
                          </TableCell>
                          {(editVisibility || deleteVisibility) && (
                            <TableCell className="thead d-flex justify-content-end">Actions</TableCell>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.cities.map((cityDetails) => (
                          <TableRow
                            key={cityDetails.city_id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell align="left" className="tData">
                              {cityDetails.city_id}
                            </TableCell>
                            <TableCell align="left" className="tData">
                              {cityDetails.name}
                            </TableCell>
                            <TableCell align="left" className="tData">
                              {cityDetails.description
                                ? cityDetails.description
                                : "No description"}
                            </TableCell>
                            {(editVisibility || deleteVisibility) && (
                              <TableCell align="right">
                                <div className="system-settings-action-group">
                                  {editVisibility && (
                                    <SystemSettingsActionButton type="edit"
                                      onClick={() =>
                                        this.toggleUpdateCityModal(
                                          cityDetails.name
                                            ? cityDetails.name
                                            : "",
                                          cityDetails.description
                                            ? cityDetails.description
                                            : "",
                                          cityDetails.city_id
                                            ? cityDetails.city_id
                                            : "",
                                          cityDetails.province_id
                                            ? cityDetails.province_id
                                            : "",
                                          false
                                        )
                                      }
                                      title="Edit Details"
                                     />
                                  )}
                                  {deleteVisibility && (
                                    <SystemSettingsActionButton type="delete"
                                      title="Delete"
                                     />
                                  )}
                                </div>
                              </TableCell>
                            )}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    <MaterialCustomTablePagination
                      totalCount = {Number(totalCities)}
                      currentPage = {Number(currentPage)}
                      limit = {Number(limit)}
                      handlePageChange = {this.handlePageChange}
                      handleRowsPerPageChange = {this.handleRowsPerPageChange}
                      handlePageOffsetChange = {this.handlePageOffsetChange}
                      offset = {Number(this.state.offset)}
                      rowsPerPageOptions={[5, 10, 20]}
                    />
                  </div>
                ) : (
                  <div className="text-center mb-5 mt-10" style={{ height: "90vh" }}>
                    <label>No Cities Available!</label>
                  </div>
                )}
              </div>
            </ContentWrapper>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showModal}
            onHide={() => this.handleSweetAlert(this.modalType, "showModal")}
          >
            {this.modalType === true ? (
              <div>
                <Modal.Header closeButton>
                  <Modal.Title>Create New City </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form>
                    <Row className="my-5">
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput2"
                      >
                        <Form.Label>Select Province *</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="province_id"
                          onChange={this.handleChange}
                          required
                        >
                          <option value="">Select</option>
                          {provinces.map((province) => (
                            <option
                              value={province.province_id}
                              key={province.province_id}
                            >
                              {province.name}
                            </option>
                          ))}
                        </Form.Select>
                        {this.validator.message(
                          "province_id",
                          this.state.province_id,
                          "required",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The province field is required",
                            },
                          }
                        )}
                      </Form.Group>
                    </Row>
                    <Row className="my-5">
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>City Name *</Form.Label>
                        <Form.Control
                          type="text"
                          name="cityName"
                          placeholder="City Name"
                          onChange={this.handleChange}
                        />
                        {this.validator.message(
                          "cityName",
                          this.state.cityName,
                          "required|alpha_space|max:30",
                          {
                            className: "text-danger",
                            messages: {
                              max: "The city name should not be greater than 30 characters.",
                              alpha_space:
                                "The city name must have valid characters.",
                              required: "The city name field is required",
                            },
                          }
                        )}
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          type="text"
                          name="cityDescription"
                          placeholder="Description"
                          onChange={this.handleChange}
                        />
                        {this.validator.message(
                          "cityDescription",
                          this.state.cityDescription,
                          "alpha_space|max:100",
                          {
                            className: "text-danger",
                            messages: {
                              max: "The city description should not be greater than 100 characters.",
                              alpha_space:
                                "The city description must have valid characters.",
                            },
                          }
                        )}
                      </Form.Group>
                    </Row>
                  </Form>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="primary" style={ addBtnStyle } onClick={this.handleSubmit}>
                    Save changes
                  </Button>
                  <Button
                    id="modal-close-button"
                    style={ closeBtnStyle }

                    onClick={() =>
                      this.handleSweetAlert(this.modalType, "showModal")
                    }
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </div>
            ) : (
              <div>
                <Modal.Header closeButton>
                  <Modal.Title>Update City Information</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form>
                    <Row className="my-5">
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput2"
                      >
                        <Form.Label>Select Province *</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="province_id"
                          onChange={this.handleChange}
                          required
                          value={this.state.province_id}
                        >
                          <option value="">Select</option>
                          {provinces.map((province) => (
                            <option
                              value={province.province_id}
                              key={province.province_id}
                            >
                              {province.name}
                            </option>
                          ))}
                        </Form.Select>
                        {this.validator.message(
                          "province_id",
                          province_id,
                          "required",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The province field is required",
                            },
                          }
                        )}
                      </Form.Group>
                    </Row>
                    <Row className="my-5">
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>City Name *</Form.Label>
                        <Form.Control
                          type="text"
                          name="cityName"
                          placeholder="City Name"
                          defaultValue={cityName}
                          onChange={this.handleChange}
                        />
                        {this.validator.message(
                          "cityName",
                          cityName,
                          "required|alpha_space|max:30",
                          {
                            className: "text-danger",
                            messages: {
                              max: "The city name should not be greater than 30 characters.",
                              alpha_space:
                                "The city name must have valid characters.",
                              required: "The city name field is required",
                            },
                          }
                        )}
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          type="text"
                          name="cityDescription"
                          placeholder="Description"
                          defaultValue={cityDescription}
                          onChange={this.handleChange}
                        />
                        {this.validator.message(
                          "cityDescription",
                          cityDescription,
                          "alpha_space|max:100",
                          {
                            className: "text-danger",
                            messages: {
                              max: "The city description should not be greater than 100 characters.",
                              alpha_space:
                                "The city description must have valid characters.",
                            },
                          }
                        )}
                      </Form.Group>
                    </Row>
                  </Form>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="modal-btn"
                    variant="primary"
                    style={ addBtnStyle }
                    onClick={this.handleEditSubmit}
                  >
                    Save changes
                  </Button>
                  <Button
                    className="modal-btn"
                    id="modal-close-button"
                    style={ closeBtnStyle }
                    onClick={() =>
                      this.handleSweetAlert(this.modalType, "showModal")
                    }
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </div>
            )}
          </Modal>
      </>
    );
  }
}

